import loadable from '@loadable/component';

export const AnandtechSiteWrapper = loadable(
  () => import(/* webpackChunkName: "anandtech-site" */ './AnandtechSiteWrapper'),
);
